module.exports = "https://dev.stanwinstonschool.com/theabyss_poster_org Large.f8377f5527651d1ca748a609eb5bb89c.jpeg";